export const ROLE_TINT = {
  engineer:  '#4CEB9F',
  designer:  '#FFC5F6',
  exec:      '#6B53FD',
  customer:  '#FDBC45',
  sales:     '#EF7E46',
  data:      '#EFF2FF',
  intern:    '#FCF3DF',
  recruiter: '#4C975B',
};

export const ROLE_LABEL = {
  engineer:  'Engineering',
  designer:  'Design',
  exec:      'Executive',
  customer:  'Customer',
  sales:     'Sales',
  data:      'Data',
  intern:    'Intern',
  recruiter: 'Recruiting',
};
